import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddBrandLogoModalComponent } from '../views/shared/modals/add-brand-logo-modal/add-brand-logo-modal.component';
import { AddBrandLogoModalConfig } from '../views/shared/modals/add-brand-logo-modal/add-brand-logo-modal-view-model';
import { ModalUtils } from '../utils/modal-utils';

export class ModalAddBrandLogo {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    config: AddBrandLogoModalConfig,
    onCloseIfNotCancelled?: (logoUploaded: boolean) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(AddBrandLogoModalComponent, ModalUtils.addBrandLogoModalOptions(injector));
      const compInstance = modalRef.componentInstance as AddBrandLogoModalComponent;
      compInstance.setConfig(config);
      modalRef.result
        .then(logoUploaded => {
          if (typeof logoUploaded !== 'boolean') return;
          onCloseIfNotCancelled?.(logoUploaded);
        })
        .catch(() => {});
    });
  }
}
